"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDetailGallerySaga = void 0;
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var DetailGalleryAction_1 = require("@/pages/detail/actions/DetailGalleryAction");
var DetailGalleryCallSaga_1 = require("@/pages/detail/sagas/DetailGalleryCallSaga");
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var effects_1 = require("redux-saga/effects");
var NearbyAction_1 = require("@/pages/detail/actions/NearbyAction");
var DetailPopNearbyTabType_1 = require("@/pages/detail/states/DetailPopNearbyTabType");
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var initDetailGallerySaga = function (fn) {
    var watchInitGallery = function () {
        var gallery, initIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window)
                        return [2 /*return*/];
                    return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.select(fn)];
                case 2:
                    gallery = _a.sent();
                    initIndex = gallery.currentIndex;
                    return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setGalleryIndex(gallery.id, initIndex, true))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
    var watchSetGalleryIndex = function () {
        var payload, id, index, noSmooth;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 3];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_SET_DETAIL_GALLERY_INDEX)];
                case 1:
                    payload = (_a.sent()).payload;
                    id = payload.id;
                    index = payload.index;
                    noSmooth = payload.noSmooth;
                    return [4 /*yield*/, effects_1.call(DetailGalleryCallSaga_1.setGalleryScroll, id, index, noSmooth)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 3: return [2 /*return*/];
            }
        });
    };
    var watchPrev = function () {
        var payload, id, gallery, currentIndex, prevIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 4];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_GALLERY_PREV)];
                case 1:
                    payload = (_a.sent()).payload;
                    id = payload;
                    return [4 /*yield*/, effects_1.select(fn)];
                case 2:
                    gallery = _a.sent();
                    if (gallery.id !== id)
                        return [3 /*break*/, 0];
                    currentIndex = gallery.currentIndex;
                    prevIndex = currentIndex === 0 ? gallery.items.length - 1 : currentIndex - 1;
                    return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setGalleryIndex(gallery.id, prevIndex))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    };
    var watchNext = function () {
        var payload, id, gallery, currentIndex, nextIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 4];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_GALLERY_NEXT)];
                case 1:
                    payload = (_a.sent()).payload;
                    id = payload;
                    return [4 /*yield*/, effects_1.select(fn)];
                case 2:
                    gallery = _a.sent();
                    if (gallery.id !== id)
                        return [3 /*break*/, 0];
                    currentIndex = gallery.currentIndex;
                    nextIndex = currentIndex === gallery.items.length - 1 ? 0 : currentIndex + 1;
                    return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setGalleryIndex(gallery.id, nextIndex))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    };
    var watchSlideClicked = function () {
        var _loop_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _loop_1 = function () {
                        var payload, slide, id, gallery, photoIndex, photoIndex;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_GALLERY_SLIDE_CLICK)];
                                case 1:
                                    payload = (_a.sent()).payload;
                                    slide = payload.slide;
                                    if (!(slide.type === DetailGalleryState_1.DetailGalleryItemType.VIDEO)) return [3 /*break*/, 10];
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                                case 2:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.delay(100)];
                                case 3:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.VIDEO))];
                                case 4:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoId(slide.src))];
                                case 5:
                                    _a.sent();
                                    if (!(slide.title && slide.caption)) return [3 /*break*/, 7];
                                    return [4 /*yield*/, effects_1.put(VideoAction_1.default.setVideoTitleCaption(slide.title, slide.caption))];
                                case 6:
                                    _a.sent();
                                    _a.label = 7;
                                case 7: return [4 /*yield*/, effects_1.delay(1000)];
                                case 8:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.put(VideoAction_1.default.onPlayToggle())];
                                case 9:
                                    _a.sent();
                                    return [2 /*return*/, "continue"];
                                case 10:
                                    if (!(slide.type === DetailGalleryState_1.DetailGalleryItemType.VR)) return [3 /*break*/, 14];
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                                case 11:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.delay(100)];
                                case 12:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.VR))];
                                case 13:
                                    _a.sent();
                                    return [2 /*return*/, "continue"];
                                case 14:
                                    id = payload.id;
                                    return [4 /*yield*/, effects_1.select(fn)];
                                case 15:
                                    gallery = _a.sent();
                                    if (gallery.id !== id)
                                        return [2 /*return*/, "continue"];
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                                case 16:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.delay(100)];
                                case 17:
                                    _a.sent();
                                    if (!(slide.type === DetailGalleryState_1.DetailGalleryItemType.IMAGE)) return [3 /*break*/, 20];
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.PHOTO))];
                                case 18:
                                    _a.sent();
                                    photoIndex = gallery.items
                                        .filter(function (it) {
                                        return it.type === DetailGalleryState_1.DetailGalleryItemType.IMAGE;
                                    })
                                        .findIndex(function (it) { return it.src === slide.src; });
                                    return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setGalleryIndex('detailgallery', photoIndex, true))];
                                case 19:
                                    _a.sent();
                                    _a.label = 20;
                                case 20:
                                    if (!(slide.type === DetailGalleryState_1.DetailGalleryItemType.FLOORPLAN)) return [3 /*break*/, 23];
                                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.FLOORPLAN))];
                                case 21:
                                    _a.sent();
                                    photoIndex = gallery.items
                                        .filter(function (it) {
                                        return it.type === DetailGalleryState_1.DetailGalleryItemType.FLOORPLAN;
                                    })
                                        .findIndex(function (it) { return it.src === slide.src; });
                                    return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setGalleryIndex('detailfloorplan', photoIndex, true))];
                                case 22:
                                    _a.sent();
                                    _a.label = 23;
                                case 23: return [2 /*return*/];
                            }
                        });
                    };
                    _a.label = 1;
                case 1:
                    if (!true) return [3 /*break*/, 3];
                    return [5 /*yield**/, _loop_1()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    };
    var watchMapViewClick = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 6];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_MAPVIEW_CLICK)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.NEARBY))];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, effects_1.delay(300)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES))];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 6: return [2 /*return*/];
            }
        });
    };
    var watchStreetViewClick = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 4];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_STREETVIEW_CLICK)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.STREETMAP))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    };
    var watchViewFloorPlanClick = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 4];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_FLOORPLAN_CLICK)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.FLOORPLAN))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    };
    var watchViewGalleryClick = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 4];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_GALLERY_CLICK)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.PHOTO))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    };
    var watchSlideLoaded = function () {
        var payload, slide, index, id, isPortrait;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 3];
                    return [4 /*yield*/, effects_1.take(DetailGalleryAction_1.default.ON_DETAIL_GALLERY_SLIDE_LOADED)];
                case 1:
                    payload = (_a.sent()).payload;
                    slide = payload.slide;
                    if (slide.type !== DetailGalleryState_1.DetailGalleryItemType.IMAGE)
                        return [3 /*break*/, 0];
                    index = payload.index;
                    id = payload.id;
                    isPortrait = payload.isPortrait;
                    if (!isPortrait)
                        return [3 /*break*/, 0];
                    return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setPortrait(id, index, isPortrait))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 3: return [2 /*return*/];
            }
        });
    };
    var watchPopupTabChanged = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!true) return [3 /*break*/, 4];
                    return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_SET_POP_ACTIVE_TAB)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, effects_1.take([DetailGalleryAction_1.default.ON_DETAIL_GALLERY_SLIDE_LOADED, DetailGalleryAction_1.default.ON_SET_DETAIL_GALLERY_INDEX])];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, effects_1.call(WindowApi_1.lazyLoadImages)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 4: return [2 /*return*/];
            }
        });
    };
    return {
        watchPrev: watchPrev,
        watchNext: watchNext,
        watchSetGalleryIndex: watchSetGalleryIndex,
        watchInitGallery: watchInitGallery,
        watchSlideClicked: watchSlideClicked,
        watchMapViewClick: watchMapViewClick,
        watchStreetViewClick: watchStreetViewClick,
        watchViewGalleryClick: watchViewGalleryClick,
        watchViewFloorPlanClick: watchViewFloorPlanClick,
        watchSlideLoaded: watchSlideLoaded,
        watchPopupTabChanged: watchPopupTabChanged,
    };
};
exports.initDetailGallerySaga = initDetailGallerySaga;
